<section class="edu-card">
  <div class="header-container" [style.height.px]="heightValue" [ngClass]="smallHeader ? 'small' : ''">
    <ng-content select="[card-header]"></ng-content>
  </div>
  <div class="content-container">
    <ng-content select="[card-content]"></ng-content>
  </div>
</section>